import { Component } from '@angular/core';

import { MessengerEmailComponent } from '../messages/messenger/messenger.email.component';

@Component({
  selector   : 'vendor-payment-email-remittance',
  template: require('./vendor-payment.email-remittance.component.html')
})
export class VendorPaymentEmailRemittanceComponent extends MessengerEmailComponent {}
